<script setup lang="ts">
import logo from './images/logo.svg';

const links = [
  {
    title: 'Главная',
    link: '/',
  },
  {
    title: 'CRE Awards',
    link: 'https://cre-awards.ru/',
  },
  {
    title: 'CRE +',
    link: 'https://cre.ru/plus',
  },
];
</script>

<template>
  <div :class="$style.error">
    <NuxtLink :class="$style.logoWrapper" to="/" title="На главную">
      <div :class="$style.logo" :style="{ backgroundImage: `url(${logo})` }" />
    </NuxtLink>
    <div :class="$style.code">404</div>
    <div :class="$style.title">Страница не найдена</div>
    <div :class="$style.description">
      Запрашиваемый ресурс не существует или был перемещён.
    </div>
    <div :class="$style.links">
      <NuxtLink
        v-for="(link, id) in links"
        :key="`links_${id}`"
        :class="$style.links__link"
        :to="link.link"
      >
        {{ link.title }}
      </NuxtLink>
    </div>
  </div>
</template>

<style module lang="scss">
.error {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  height: 100vh;
}

.logo {
  width: 192px;
  height: 45px;
  background: no-repeat center;
  &Wrapper {
    margin-top: 60px;
    margin-bottom: 68px;
  }
}

.code {
  color: var(--color-red-1);
  font-size: 190px;
}

.title {
  margin-bottom: 16px;
  color: var(--color-red-1);
  text-align: center;
  @include text_h1;
}

.description {
  margin-bottom: 40px;
  font-size: 18px;
  color: var(--color-black-1);
  text-align: center;
}

.links {
  display: flex;
  flex-flow: row wrap;
  gap: var(--space-4-5x);

  &__link {
    font-size: 14px;
    line-height: 140%;
    color: var(--color-black-1);
    text-decoration: none;
    &:hover {
      color: var(--color-red-1);
    }
  }
}

@media (max-width: 599px) {
  .error {
    padding-left: 24px;
    padding-right: 24px;
  }
}

@media (max-width: 479px) {
  .code {
    font-size: 170px;
  }
}
</style>
